<template>
<div>
    
    <div v-for="membership in memberships" :key="membership.id">
        <div class="membership-banner" v-if="membership">
            <div class="vip">
                <h4>VIP</h4>
                <h5>PASS</h5>
            </div>
            <div class="data">
                Hacete miembro VIP de {{membership.account.name}}
                <h3>{{membership.name}}</h3>
            </div>
            <div>
                <router-link tag="a" :to="`/m/${membership.code}/purchase`" class="btn btn-light">Comprar membresía</router-link>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import gql from 'graphql-tag'

export default {
	name: 'MembershipBanner',
    props:{
        eventId: {
            type: String,
            required: true
        }
    },
	data() {
		return {
            memberships: null,
            activeMembership: null,
		}
	},
	
    async beforeMount(){
        await this.load()
    },
	methods: {
		load() {
			return this.$apollo
				.query({
					query: gql`
						query($eventId: ID!) {
							membershipTypes(eventId: $eventId) {
                                data{
                                    id
                                    code
                                    name
                                    canBuy
                                    account{
                                        name
                                    }
                                }
							}
						}
					`,
					variables: {
						eventId: this.eventId,
					},
                    fetchPolicy: 'no-cache'
				})
				.then(({ data }) => {
                    this.memberships = data.membershipTypes.data
					return true
				})
		},
    
	},
}
</script>

<style  lang="scss">
.membership-banner{
    background-color: #161616;
    border-radius: 5px;
    color: #fff;
    display: flex;
    align-items: center;
    padding-right: 20px;
    margin-bottom: 12px;

    .vip{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 20px 10px 20px 20px;
        border-right: 4px dotted #fff;

        h4{
            font-size: 3.2rem;
            font-weight: bold;
            line-height: 3rem;
            margin-top: 5px;
        }
        h5{
            font-size: 1.12em;
            font-weight: bold;
            margin-left: -6px;
            transform: rotate(270deg);
        }
    }

    .data{
        padding: 10px 20px;
        flex-grow: 1;

        h3{
            font-size:1.2rem;
        }
    }

    .btn{
        background-color: #fff;
        color: #000 !important;
    }
  
}
</style>
